import React, { Component } from 'react'
import { Modal } from "react-bootstrap";
import moment from "moment";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import axios, { post } from "axios";


const ADD_DAIRY_ASSIGNMENT_DETAILS = gql`
  mutation($params: AddDairyAssignmentDetails) {
    addDairyAssignmentDetails(params: $params)
  }`


class AssignmentCreationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch: "",
            class: "",
            exam: "",
            section: "",
            subject: "",
            lecturer: "",
            branchError: "",
            classError: "",
            examError: "",
            sectionError: "",
            subjectError: "",
            lecturerError: "",
            title: "",
            titleError: "",
            toDate: new Date().toISOString().slice(0, 10),
            toDateError: "",
            fromDate: new Date().toISOString().slice(0, 10),
            fromDateError: "",
            getExams: [],
            getClasses: [],
            getSections: [],
            getSubjects: [],
            getEmployees: [],
            employeesData: [],
            sectionValue: [],
            defaultvalue: 0,
            description: "",
            descriptionError: "",
            uploadfile: "",
            dataClear: 0,
            loader: 0,
            submitError: "",
            submitted: false,
            marks: "",
            isDisabled: false,
            dairyAssigment_id: null,
            isSubmitting: false,
            error:""
        }
    }

    handleInputChange = async (e) => {

        const name = e.target.name;
        const value = e.target.value;


        let getArray = [];

        if (name == "branch") {
            if (value != "0") {
                this.setState({
                    branch: value,
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: "",
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    title: "",
                    titleError: "",
                    getClasses: [],
                    getSections: [],
                    sectionValue: [],
                    descriptionError: "",
                    getExams: this.getExams(value),
                })

            } else {

                this.setState({
                    branch: "",
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: "",
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    title: "",
                    titleError: "",
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    sectionValue: [],
                })
            }
        }

        if (name == "exam") {

            if (value != "0") {


                let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                let examWiseSubjects = [];
                if (this.props.globals.offlineExamSubjects.length > 0) {
                    this.props.globals.exams.filter((item) => item.id == value)[0].exam_subjects.map((item1) => {
                        this.props.globals.offlineExamSubjects.map((item2) => {
                            if (item1.subject_id == item2.id) {
                                const newObj = {
                                    value: item2.id,
                                    label: item2.subject
                                }
                                examWiseSubjects.push(newObj);

                            }
                        })
                    })
                }

                this.setState({
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: value,
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    title: "",
                    titleError: "",
                    getClasses: this.getClasses(this.state.branch, value),
                    getSubjects: examWiseSubjects,
                    getSections: [],
                    sectionValue: [],
                })

                this.getEmployess(this.state.branch)
            } else {
                this.setState({
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: "",
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    title: "",
                    titleError: "",
                    getSections: [],
                    getClasses: [],
                    sectionValue: [],
                })

            }
        }

        if (name == "class") {

            if (value != "0") {

                let uniqueSections = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == this.state.exam && item.class_id == value).map((item1) => item1.section_id))].sort();

                uniqueSections.map((val) => {
                    let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualSectionData.id,
                        label: individualSectionData.section_name
                    }
                    getArray.push(newObj);
                })

                let sections = getArray.map((item) => item.value).toString();

                this.setState({
                    branchError: "",
                    section: sections,
                    sectionError: "",
                    class: value,
                    classError: "",
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    title: "",
                    titleError: "",
                    getSections: this.getSections(this.state.branch, this.state.exam, value),
                    sectionValue: getArray
                })

            } else {

                this.setState({
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    examError: "",
                    subject: "",
                    subjectError: "",
                    lecturer: "",
                    lecturerError: "",
                    title: "",
                    titleError: "",
                    getSections: [],
                    sectionValue: [],
                })

            }

        }


        if (name == "subject") {
            if (value != "0") {
                let lecturesData = [];

                if (this.state.getEmployees.length > 0) {

                    lecturesData = this.state.getEmployees.filter((item) => item.subject_ids.includes(value))
                }
                this.setState({
                    subject: value,
                    subjectError: "",
                    employeesData: lecturesData
                })
            } else {

                this.setState({
                    section: "",
                    sectionError: "",
                    subjectError: "",
                    title: "",
                    titleError: "",
                })
            }


        }

        if (name == "lecturer") {
            if (value != "0") {
                this.setState({
                    lecturer: value,
                    lecturerError: "",
                })
            } else {
                this.setState({
                    lecturer: "",
                    subject: "",
                    subjectError: "",
                    lecturerError: "",
                    title: "",
                    titleError: "",
                })
            }
        }

    };

    handleChange = async (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name == "title") {
            this.setState({
                title: value,
                titleError: "",
                descriptionError: ""
            })
        }

        if (name == "marks") {
            this.setState({
                marks: value,
            })
        }

        if (name == "fromDate") {
            this.setState({
                fromDate: value,
                fromDateError: ""
            })
        }

        if (name == "toDate") {
            this.setState({
                todate: value,
                toDateError: ""
            })
        }

        if (name === "uploadfile") {
            const selectedFile = e.target.files[0];
            const fileType = selectedFile.type;
        
            if (fileType !== 'application/pdf') {
                // Display an error message if the file is not a PDF
                this.setState({ error: 'Only PDF files are allowed.' });
                return; // Stop further execution
            }else{
                this.setState({ error:"" })
            }
        
            const formData = new FormData();
            formData.append('file', selectedFile);
            console.log("filessssssss", selectedFile);
        
            axios.post('https://rizee.in/pdfFiles.php?dairyAssignmentFiles=true', formData)
                .then((response) => {
                    console.log("response", response);
                    this.setState({ uploadfile: response.data.filename });
                })
                .catch((error) => {
                    this.setState({ error: 'An error occurred while uploading the file.' });
                });
        }

        if (name == "description") {
            this.setState({
                description: value,
                descriptionError: ""
            })
        }


        this.setState({ [name]: value });
    }


    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                branch: "",
                branchError: "",
                exam: "",
                examError: "",
                section: "",
                sectionError: "",
                class: "",
                classError: "",
                subject: "",
                subjectError: "",
                lecturer: "",
                lecturerError: "",
                title: "",
                titleError: "",
                marks: "",
                uploadfile: "",
                fromDate: new Date().toISOString().slice(0, 10),
                toDate: new Date().toISOString().slice(0, 10),
                description: "",
                sectionValue: [],
                descriptionError: "",
                loader: 0,
                submitError: "",
                dataClear: 1,
                submitted: false,
                dataClear: 1,
                error:""

            })
            if (this.props.stateData.existingAssignmentData.length > 0) {
                let existingData = this.props.stateData.existingAssignmentData[0];

                let employees = this.props.stateData.getEmployees.map((item) => {
                    const newObj = {
                        employee_id: item.value,
                        employee_name: item.label
                    }
                    return newObj
                })

                let sectionValue = []
                let sectionIds = existingData.section_id.split(',');
                sectionIds.forEach(id => {
                    let data = this.props.globals.globalSections.find(item => item.id === id);
                    if (data) {
                        let newObj = {
                            value: +data.id,
                            label: data.section_name
                        };
                        sectionValue.push(newObj);
                    }
                });
                this.setState({
                    branch: existingData.branch_id,
                    exam: existingData.exam_id,
                    class: existingData.class_id,
                    section: existingData.section_id,
                    subject: existingData.subject_i,
                    lecturer: existingData.employee_i,
                    getExams: this.getExams(existingData.branch_id),
                    getClasses: this.getClasses(existingData.branch_id, existingData.exam_id),
                    // getSections: sectionValue,
                    sectionValue: sectionValue,
                    getSubjects: this.getSubjects(existingData.exam_id),
                    getEmployees: employees,
                    employeesData: employees,
                    title: existingData?.title,
                    fromDate: moment(existingData.from_date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    toDate: moment(existingData.to_date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    marks: existingData.marks,
                    description: existingData.description,
                    uploadfile: existingData.file_path,
                    dairyAssigment_id: existingData.dairyAssignmentId,
                    isDisabled: true,
                    error:""
                })

            } else {
                this.setState({
                    branch: "",
                    exam: "",
                    class: "",
                    section: "",
                    subject: "",
                    lecturer: "",
                    marks: "",
                    fromDate: new Date().toISOString().slice(0, 10),
                    getEmployees: [],
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    getSubjects: [],
                    isDisabled: false
                })
            }

        }

        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }


    }

    getExams = (branch_id) => {
        let getArray = [];

        let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branch_id).map((item1) => item1.exam_id))].sort();

        uniqueExams.map((val) => {
            let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
            const newObj = {
                value: individualExamData.id,
                label: individualExamData.exam
            }
            getArray.push(newObj);
        })
        return getArray
    }

    getClasses = (branch_id, exam_id) => {

        let getArray = [];

        let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branch_id && item.exam_id == exam_id).map((item1) => item1.class_id))].sort();

        uniqueClasses.map((val) => {
            let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
            const newObj = {
                value: individualClassData.id,
                label: individualClassData.class
            }
            getArray.push(newObj);
        })
        return getArray
    }

    getSections = (branch_id, exam_id, class_id) => {

        let getArray = [];

        let uniqueSections = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branch_id && item.exam_id == exam_id && item.class_id == class_id).map((item1) => item1.section_id))].sort();

        uniqueSections.map((val) => {
            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
            const newObj = {
                value: individualSectionData.id,
                label: individualSectionData.section_name
            }
            getArray.push(newObj);
        })

        return getArray


    };


    getSubjects = (exam_id) => {


        let examWiseSubjects = [];

        if (this.props.globals.offlineExamSubjects.length > 0) {
            this.props.globals.exams.filter((item) => item.id == exam_id)[0].exam_subjects.map((item1) => {
                this.props.globals.offlineExamSubjects.map((item2) => {
                    if (item1.subject_id == item2.id) {
                        const newObj = {
                            value: item2.id,
                            label: item2.subject
                        }
                        examWiseSubjects.push(newObj);

                    }
                })
            })
        }
        const newObj = {
            value: 0,
            label: "Others"
        }
        examWiseSubjects.push(newObj);
        return examWiseSubjects;
    }


    getEmployees = (subject_id) => {
        console.log("subject_id", subject_id);
        let lecturesData = [];

        if (this.state.getEmployees.length > 0) {

            lecturesData = this.state.getEmployees.filter((item) => item.subject_ids == subject_id)

            this.setState({ employeesData: lecturesData })
        }
    }

    getEmployess = async (val) => {

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,){
                getEmployees(institute_id:$institute_id,branch_id:$branch_id){
                  employee_id
                  employee_name
                  subject_ids
                  employee_type_id
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val)
            },
            fetchPolicy: 'network-only'
        })
        let employeeFilterData = result.data.getEmployees.filter((a) => a.employee_type_id == 3)
        console.log("employeeFilterData", employeeFilterData);
        if (employeeFilterData.length > 0) {
            this.setState({ getEmployees: employeeFilterData })

        } else {
            this.setState({ getEmployees: [] })
        }
    };


    handleFormSubmit = (e) => {


        if (this.state.branch === "" || this.state.branch === "--Select Branch--") {
            this.setState({ branchError: "Please select branch" });
            return ""
        }


        if (this.state.exam === "" || this.state.exam === "--Select Exam--") {
            this.setState({ examError: "Please select exam" });
            return ""
        }

        if (this.state.class === "" || this.state.class === "--Select Class--") {
            this.setState({ classError: "Please select class" });
            return ""
        }


        if (this.state.section === "" || this.state.section === "--Select Section--") {
            this.setState({ sectionError: "Please select section" });
            return ""
        }


        if (this.state.subject === "" || this.state.subject === "--Select Subject--") {
            this.setState({ subjectError: "Please select subject" });
            return ""
        }


        if (this.state.lecturer === "" || this.state.lecturer === "--Select Lecture--") {
            this.setState({ lecturerError: "Please select lecture" });
            return ""
        }


        if (this.state.title == "" || this.state.title === "Enter Title") {
            this.setState({ titleError: "Please enter title", })
            return ""
        }

        if (this.state.fromDate == "") {
            this.setState({ fromDateError: "Please select date", })
            return ""
        }

        if (this.state.toDate == "") {
            this.setState({ toDateError: "Please select date", })
            return ""
        }
        if (this.state.error != "") {
            this.setState({ error: "Only PDF files are allowed.", })
            return ""
        }

        if (this.state.description == "") {
            this.setState({ descriptionError: "Please write description", })
            return ""
        }

        this.setState({
            loader: 1
        });

        this.setState({
            isSubmitting: true
        })

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch),
            class_id: this.state.class,
            exam_id: this.state.exam,
            section_ids: this.state.section,
            subject_id: parseInt(this.state.subject),
            employee_id: parseInt(this.state.lecturer),
            from_date: moment(this.state.fromDate, 'YYYY-MM-DD').unix().toString(),
            to_date: moment(this.state.toDate, 'YYYY-MM-DD').unix().toString(),
            title: this.state.title,
            file_path: this.state.uploadfile == "" || this.state.uploadfile == undefined ? "" : `https://rizee.in/educational_mngt/dairy_assignment_files/${this.state.uploadfile}`,
            dairy_assignment_type_id: parseInt(3),
            description: this.state.description,
            assignment_marks: parseInt(this.state.marks),
            inserted_by: parseInt(Cookies.get("id")),
            dairy_assignment_id: parseInt(this.state.dairyAssigment_id)
        };
        console.log('params', params);

        this.addDairyAssignmentDetails(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loader: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
        this.setState({ loader: 1 })
    }

    addDairyAssignmentDetails = async (
        params) => {
        await this.props.addDairyAssignmentDetails({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addDairyAssignmentDetails) {
                    this.setState({
                        loader: 0,
                        submitted: true
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }

        });
    };

    handleMultipleSelectInputChange = async (e, name) => {
        console.log("multi", e);
        let sectionValue = []
        let section = "";
        if (e.length > 0) {
            section = e.map((item) => item.value).toString()
            for (let i = 0; i < e.length; i++) {
                const sectionVal = e[i];
                const newObj = {
                    value: sectionVal.value,
                    label: sectionVal.label
                }
                sectionValue.push(newObj)
            }
            this.setState({
                sectionValue: sectionValue,
                getSubjects: this.getSubjects(this.state.exam),
                sectionError: "",
                section,
                subject: "",
                subjectError: "",
            });

        } else {
            this.setState({
                sectionValue: [],
                sectionError: "",
                section: "",
                subject: "",
                subjectError: "",
            });
        }

    }

    render() {

        const styles = {
            cursor: this.state.isSubmitting ? "not-allowed" : "pointer",
            backgroundColor: this.state.isSubmitting ? "#213046" : "#213046",
            color: this.state.isSubmitting ? "#fff" : "#fff",
            padding: this.state.isSubmitting ? "8px" : "8px",
            width: this.state.isSubmitting ? "158px" : "158px",
            border:this.state.isSubmitting ? "none" : "none",
        };

        console.log(this.props, this.state, "eeeeeeeee")

        let sectionSelectAll = true;
        let sectionlabelledby = "--Select Sections--";
        let sectiondisablesearch = false;
        if (this.state.getSections.length > 0) {
            sectionSelectAll = true;
            sectiondisablesearch = false;
        }
        else {
            sectiondisablesearch = true;
            sectionSelectAll = false;
            sectionlabelledby = "--Select Sections--"
        }


        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Assignment Creation</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="font-weight-bold">Branch</Form.Label>
                                        <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch} disabled={this.state.isDisabled} isInvalid={this.state.branchError}>
                                            <option >--Select Branch--</option>
                                            {this.props.globals.globalBranches.map(branchdata => (
                                                <option key={branchdata.id} value={branchdata.id} selected={this.state.branch == branchdata.id ? true : false}>
                                                    {branchdata.branch_name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>


                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectExam">
                                        <Form.Label className="font-weight-bold">Exam</Form.Label>
                                        <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam} disabled={this.state.isDisabled} isInvalid={this.state.examError}>
                                            <option>--Select Exam--</option>
                                            {this.state.getExams.map(item => (
                                                <option key={item.value} value={item.value} selected={this.state.exam == item.value ? true : false}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.examError}
                                        </Form.Text>
                                    </Form.Group>


                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectClass">
                                        <Form.Label className="font-weight-bold">Class</Form.Label>
                                        <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class} disabled={this.state.isDisabled} isInvalid={this.state.classError}>
                                            <option>--Select Class--</option>
                                            {this.state.getClasses.map(classdata => (
                                                <option key={classdata.value} value={classdata.value} selected={this.state.class == classdata.value ? true : false}>
                                                    {classdata.label}
                                                </option>
                                            ))}

                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.classError}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectSection"  >
                                        <Form.Label className="font-weight-bold">Section</Form.Label>
                                        <MultiSelect
                                            overrideStrings={{
                                                allItemsAreSelected: "All Sections are selected.",
                                                selectSomeItems: sectionlabelledby
                                            }
                                            }
                                            disableSearch={sectiondisablesearch}
                                            hasSelectAll={sectionSelectAll}
                                            options={this.state.getSections}
                                            value={this.state.sectionValue}
                                            selected={this.state.section.includes(this.state.sectionValue.map((i) => i.value)) ? true : false}
                                            disabled={this.state.isDisabled}
                                            onChange={(e) => this.handleMultipleSelectInputChange(e, "sections")}
                                            labelledBy={"Sections"}
                                        />
                                        <Form.Text className="form-text text-danger">
                                            {this.state.sectionError}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectSubject">
                                        <Form.Label className="font-weight-bold">Subject</Form.Label>
                                        <Form.Control as="select" name="subject" onChange={this.handleInputChange} value={this.state.subject} disabled={this.state.isDisabled} isInvalid={this.state.subjectError}>
                                            <option >--Select Subject--</option>
                                            {this.state.getSubjects.map(subjectdata => (
                                                <option key={subjectdata.value} value={subjectdata.value} selected={this.state.subject == subjectdata.value ? true : false}>
                                                    {console.log(subjectdata.value, "subjectdata.value")}
                                                    {subjectdata.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.subjectError}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectLecture">
                                        <Form.Label className="font-weight-bold">Lecture Name</Form.Label>
                                        <Form.Control as="select" name="lecturer" onChange={this.handleInputChange} value={this.state.lecturer} disabled={this.state.isDisabled} isInvalid={this.state.lecturerError}>
                                            <option >--Select Lecture--</option>
                                            {this.state.employeesData.map(employeedata => (
                                                <option key={employeedata.employee_id} value={employeedata.employee_id} selected={this.state.lecturer == employeedata.employee_id ? true : false}>
                                                    {employeedata.employee_name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.lecturerError}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={4} md={12} sm={12}>
                                        <div>
                                            <div ><label className='font-weight-bold'>Assignment Title</label></div>
                                            <input type='text' className='form-control' placeholder="Enter Title" name="title" value={this.state?.title} disabled={this.state.isDisabled} onChange={this.handleChange} />
                                        </div>
                                        <span className="text-danger">{this.state.titleError}</span>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={4} md={12} sm={12}>
                                        <div>
                                            <div><label  className='font-weight-bold'>Assignment Marks</label></div>
                                            <input type='number' className='form-control' placeholder="Enter Marks" name="marks" value={this.state.marks} onChange={this.handleChange} disabled={this.state.isDisabled} />
                                        </div>
                                    </Form.Group>


                                    <Form.Group as={Col} lg={4} md={12} sm={12}>
                                        <div>
                                            <div><label  className='font-weight-bold'>Upload File</label></div>
                                            <input type='file' className='form-control' name="uploadfile" onChange={this.handleChange} disabled={this.state.isDisabled} />
                                            <p>
                                                {this.props.stateData.existingAssignmentData.length > 0 && this.state.uploadfile !== "" ? (
                                                    <p className='text-success'>File Uploaded</p>
                                                ) : (
                                                    ""
                                                )}
                                            </p>
                                            {
                                                    this.state.error != "" ?(
                                                        <p className='text-danger'>{this.state.error}</p>
                                                    ):""
                                                }

                                        </div>
                                    </Form.Group>

                                </Form.Row>
                            </Form>
                            <section>
                                <Row>
                                    <Col as={Col} lg={3} md={12} sm={12}>
                                        <div>
                                            <div><label className='font-weight-bold'>Assign Date</label></div>
                                            <input type='date' className='form-control' name="fromDate" onChange={this.handleChange} value={this.state.fromDate} disabled={this.state.isDisabled} style={{ borderRadius: "15px" }} />                                        </div>

                                        <span className="text-danger">{this.state.fromDateError}</span>
                                    </Col>


                                    <Col as={Col} lg={3} md={12} sm={12}>
                                        <div>
                                            <div ><label className='font-weight-bold'>End Date</label></div>
                                            <input type='date' className='form-control' name="toDate" onChange={this.handleChange} value={this.state.toDate} style={{ borderRadius: "15px" }} />                                        </div>

                                        <span className="text-danger">{this.state.toDateError}</span>
                                    </Col>

                                    <Col as={Col} lg={6} md={12} sm={12}>
                                        <div ><label className='font-weight-bold mt-1'>Description</label></div>
                                        <textarea className='form-control' name="description" onChange={this.handleChange} value={this.state.description} ></textarea>
                                        <span className='text-danger'>{this.state.descriptionError}</span>
                                    </Col>

                                </Row>
                            
                                <Modal.Footer variant="white" className="px-4">
                                    <Row>
                                        <div className='d-block'>
                                            {
                                                this.state.submitted == true ? (
                                                    <p className="text-success mt-1" >Assignment Created Successfully</p>
                                                ) : ""
                                            }
                                            {
                                                this.state.submitError != "" ? (
                                                    <span className="text-danger mt-1">{this.state.submitError}</span>
                                                ) : ("")
                                            }
                                        </div>
                                    </Row>
                                    <Row>
                                        <Col sm={12}>
                                            <button style={styles}  className="text-uppercase" disabled={this.state.isSubmitting} onClick={this.handleFormSubmit}>
                                                {
                                                    this.state.loader == 1 ? (
                                                        <span className="spinner-border spinner-border-sm"></span>
                                                    ) : ""
                                                }
                                                Create Assignment</button>
                                        </Col>
                                    </Row>
                                </Modal.Footer>
                            </section>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}

export default
    withRouter(withApollo(
        graphql(ADD_DAIRY_ASSIGNMENT_DETAILS, {
            name: "addDairyAssignmentDetails"
        })
            (AssignmentCreationModal)));